const state = {
  permissaoNegada: {
    msg: '',
    status: true,
    show: false
  }
}

const mutations = {
  setPermissaoNegada (state, obj) {
    state.permissaoNegada = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/permissaoNegada.js